import { DeleteOutlined } from '@ant-design/icons'
import type { components } from '@fluencelabs/vodopad-admin-api'
import { Button, type TableColumnsType, Typography } from 'antd'

import { ClusterNameLink } from '@/components/common/ClusterNameLink'
import { FormattedDate } from '@/components/common/FormattedDate'
import { MONO_STYLE } from '@/components/common/MonoId'
import { StatusTag } from '@/components/common/StatusTag'
import { UserEmailLink } from '@/components/common/UserEmailLink'
import { VM_TERMINAL_STATUSES } from '@/constants/statuses'

type UserVmDto = components['schemas']['AdminUserVmDto']

export function vmColumns(
  onTerminate: (record: UserVmDto) => void,
): TableColumnsType<UserVmDto> {
  return [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 160,
      ellipsis: true,
      render: (id: string) => (
        <Typography.Text copyable={{ text: id }} style={MONO_STYLE}>
          {id.slice(0, 8)}...
        </Typography.Text>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      render: (name: string) => (
        <Typography.Text
          copyable={{ text: name }}
          ellipsis={{ tooltip: name }}
          style={{ maxWidth: '100%' }}
        >
          {name}
        </Typography.Text>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 110,
      render: (s: string) => <StatusTag status={s} />,
    },
    {
      title: 'User',
      dataIndex: 'userId',
      key: 'userId',
      ellipsis: true,
      render: (id: string) => (id ? <UserEmailLink userId={id} /> : '—'),
    },
    {
      title: 'Cluster',
      dataIndex: 'clusterId',
      key: 'clusterId',
      ellipsis: true,
      render: (id: string) => (id ? <ClusterNameLink clusterId={id} /> : '—'),
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 180,
      render: (d: string) => <FormattedDate date={d} fmt="PPp" />,
    },
    {
      title: '',
      key: 'actions',
      width: 50,
      render: (_: unknown, record: UserVmDto) => (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          disabled={VM_TERMINAL_STATUSES.has(record.status)}
          onClick={() => onTerminate(record)}
        />
      ),
    },
  ]
}
